export default class AgendaEnum {
    static BODY = 'body'
    static BANNER = '[data-element="banner"]'
    static HEADING = '[data-element="heading"]'
    static TRIGGER_AGENDA = '[data-trigger="agenda-toggle"]'
    static CUSTOMER_AGENDA = '[data-element="customer-agenda"]'
    static ECOMODE = '[data-id="eco-bar"]'
}
